import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import ModificationsSidebar from 'components/ModificationsSidebar';
import { toggleModificationsSidebar } from 'actions/viewStates';
import Icon from './Icon';
import './MatrixSidebar.scss';

const ChangesToggle = ({ onToggle, value, disabled }) => {
  const onClick = useCallback(
    v => {
      onToggle(v);
    },
    [onToggle]
  );

  return (
    <div className="ChangesToggle-button-container">
      {!disabled ? (
        <div className="ChangesToggle-radio-button">
          <div
            className={classnames(
              'ChangesToggle-radio-button-select tour-changes-from-base-matrix',
              {
                active: value === 'session',
              }
            )}
            onClick={() => onClick('comparison')}
          >
            <div
              className={classnames('ChangesToggle-radio-button-select-inner', {
                active: value === 'comparison',
              })}
            ></div>
          </div>
          <div className="ChangesToggle-radio-button-label">
            From base matrix
          </div>
        </div>
      ) : null}
      <div className="ChangesToggle-radio-button">
        {!disabled ? (
          <div
            className={classnames('ChangesToggle-radio-button-select', {
              active: value === 'session',
            })}
            onClick={() => onClick('session')}
          >
            <div
              className={classnames('ChangesToggle-radio-button-select-inner', {
                active: value === 'session',
              })}
            ></div>
          </div>
        ) : null}
        <div className="ChangesToggle-radio-button-label">
          Made this session
        </div>
      </div>
    </div>
  );
};

const MatrixSidebar = ({ base, matrix }) => {
  const dispatch = useDispatch();

  // Should always be 'session' or 'comparison'
  const [visibleChanges, setVisibleChanges] = useState('session');

  const initialSessionMatrices = useSelector(
    state => state.matrices.sessionMatrices
  );

  const initialSessionMatrix = useMemo(() => {
    return initialSessionMatrices?.[matrix?.id];
  }, [matrix, initialSessionMatrices]);

  const modificationsOpen = useSelector(
    state => state.viewStates.modificationsSidebarOpen
  );

  const baseMatrix = useMemo(() => {
    if (visibleChanges === 'session') {
      return initialSessionMatrix;
    }
    return base ? base : matrix;
  }, [initialSessionMatrix, base, matrix, visibleChanges]);

  return (
    <>
      <div
        className={`MatrixSidebar MatrixSidebar-Modifications interactiveTourGettingStarted-10 ${
          !modificationsOpen ? 'disabled' : ''
        }`}
      >
        {!modificationsOpen ? (
          <div className="MatrixSidebar-stickyTopContainer">
            <div
              className="SectionHeader-icon"
              onClick={() => dispatch(toggleModificationsSidebar())}
            >
              <Icon alt={'edit'} icon={'edit'} />
            </div>
          </div>
        ) : (
          <div className="MatrixSidebar-scrollContainer">
            <div className="MatrixSidebar-section-header-container">
              <div
                className="SectionHeader-icon"
                onClick={() => dispatch(toggleModificationsSidebar())}
              >
                <Icon alt={'edit'} icon={'edit'} />
              </div>
              <div className="MatrixSidebar-header">
                <div className="MatrixSidebar-header-bold">Changes</div>
              </div>
            </div>
            <div className="MatrixSidebar-changes-toggle-container">
              <ChangesToggle
                onToggle={setVisibleChanges}
                value={visibleChanges}
                disabled={!base}
              />
            </div>
            {matrix && matrix?.nodes && baseMatrix && baseMatrix?.nodes ? (
              <ModificationsSidebar matrix={baseMatrix} experiment={matrix} />
            ) : null}
          </div>
        )}
      </div>
    </>
  );
};

export default MatrixSidebar;
